import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

export interface PartnerCode {
  id: string;
  partner_id: string;
  code: string;
  label: string;
  is_active: boolean;
  created_at: string;
}

export function usePartnerCodes(partnerId: string | null) {
  const query = useQuery({
    queryKey: ["partner-codes", partnerId],
    enabled: !!partnerId,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("partner_referral_codes")
        .select("*")
        .eq("partner_id", partnerId!)
        .order("created_at", { ascending: false });
      if (error) throw error;
      return (data as PartnerCode[]) ?? [];
    },
  });

  return {
    data: query.data,
    codes: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error as Error | null,
    refetch: query.refetch,
  };
}
